import { render, staticRenderFns } from "./CompaniesList.vue?vue&type=template&id=114d54d1&scoped=true&"
import script from "./CompaniesList.vue?vue&type=script&lang=js&"
export * from "./CompaniesList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "114d54d1",
  null
  
)

export default component.exports